<template>
  <div class="letters-container pb-2 pb-xs-3 pb-sm-3 pb-md-5"
       v-bind:class="{ 'are-letters-waving': areLettersWaving, 'are-letters-paused': !areLettersWaving }"
  >
    <div class="phrase-simple text-nowrap">
      Radio . Kids . Online
    </div>
    <div class="d-inline-block text-nowrap">
      <span class="phrase-radio-kids">
        <span class="for-0 basic-letter letter letter-r"></span>
        <span class="for-1 basic-letter letter letter-a ml1"></span>
        <span class="for-2 basic-letter letter letter-d ml1"></span>
        <span class="for-3 letter letter-i ml1"></span>
        <span class="for-4 letter letter-flamingo ml2 mr2"></span>
        <span class="for-5 basic-letter letter letter-k ml1"></span>
        <span class="for-6 letter letter-i ml1"></span>
        <span class="for-7 basic-letter letter letter-d ml1"></span>
        <span class="for-8 letter letter-s ml1"></span>
        <span class="for-9 letter letter-dot ml4"></span>
      </span>
      <span class="phrase-online">
        <span class="for-10 letter letter-flamingo ml3 mr3"></span>
        <span class="for-11 basic-letter letter letter-n ml1"></span>
        <span class="for-12 basic-letter letter letter-l ml5"></span>
        <span class="for-13 letter letter-i ml1"></span>
        <span class="for-14 basic-letter letter letter-n ml1"></span>
        <span class="for-15 basic-letter letter letter-e ml1"></span>
      </span>
    </div>
  </div>
</template>

<script>
import {RadioPlayerInstance} from '@/App.vue'

export default {
  name: 'HeaderLetters',
  data () {
    return {
      areLettersWaving: true,
      isMusicPlaying: false
    }
  },
  created () {
    let vm = this
    RadioPlayerInstance.$on('EventMusicStatusChanged', function (isPlaying) {
      vm.isMusicPlaying = isPlaying
      vm.areLettersWaving = isPlaying
    })
    setTimeout(
      () => {
        if (!vm.isMusicPlaying) {
          vm.areLettersWaving = false
        }
      },
      15000
    )
  }
}
</script>

<style lang="scss" scoped>
  @import "compass/css3";
  @import '../../variables.scss';

  $animationDuration: 6s;
  $numberOfLettersFull: 16;
  $numberOfLettersTiny: 10;
  $animationDelayMultiplier: 2;
  $animationAngle: 11deg;

  $animationAmplitudeBig: 60px;
  $animationAmplitudeSmall: 30px;
  $animationAmplitudeTiny: 20px;

  /* Letter images: */
  .letter-a {
    background: url("/public/img/header/a.svg") no-repeat;
  }
  .letter-d {
    background: url("/public/img/header/d.svg") no-repeat;
  }
  .letter-e {
    background: url("/public/img/header/e.svg") no-repeat;
  }
  .letter-i {
    background: url("/public/img/header/i.svg") no-repeat;
  }
  .letter-k {
    background: url("/public/img/header/k.svg") no-repeat;
  }
  .letter-l {
    background: url("/public/img/header/l.svg") no-repeat;
  }
  .letter-n {
    background: url("/public/img/header/n.svg") no-repeat;
  }
  .letter-r {
    background: url("/public/img/header/r.svg") no-repeat;
  }
  .letter-s {
    background: url("/public/img/header/s.svg") no-repeat;
  }
  .letter-flamingo {
    background: url("/public/img/header/flamingo.png") no-repeat;
  }
  .letter-dot {
    background: url("/public/img/header/dot.png") no-repeat;
  }

  .letter {
    display: inline-block;
    @media screen {
      @include background-size(100% 100% !important);
    }
  }

  /* Desktop breakpoint: */
  $letterHeightLg: 110px;
  @media (min-width: $width-large) {
    /* Letter sizing: */
    .basic-letter {
      @media screen {
        height: $letterHeightLg;
        width: 68px;
      }
    }
    .letter-flamingo {
      @media screen {
        height: 199px;
        width: 205px;
      }
    }
    .letter-dot {
      margin-bottom: 30px;
      @media screen {
        height: 45px;
        width: 45px;
      }
    }
    .letter-i {
      @media screen {
        height: $letterHeightLg;
        width: 55px;
      }
    }
    .letter-s {
      @media screen {
        height: $letterHeightLg;
        width: 51px;
      }
    }

    /* Letter spacing: */
    .ml1 {
      margin-left: -15px;
    }
    .ml2 {
      margin-left: -101px;
    }
    .ml3 {
      margin-left: -90px;
    }
    .ml4 {
      margin-left: -5px;
    }
    .mr2 {
      margin-right: -35px;
    }
    .mr3 {
      margin-right: -40px;
    }
    .ml5 {
      margin-left: -15px;
    }
  }

  /* Tablet breakpoint: */

  $letterHeightMd: 86px;
  @media only screen and (min-width: $width-medium) and (max-width: $width-large - 1) {
    /* Letter sizing: */
    .basic-letter {
      @media screen {
        height: $letterHeightMd;
        width: 65px;
      }
    }
    .letter-flamingo {
      @media screen {
        height: 148px;
        width: 155px;
      }
    }
    .letter-dot {
      margin-bottom: 30px;
      @media screen {
        height: 27px;
        width: 23px;
      }
    }
    .letter-i {
      @media screen {
        height: $letterHeightMd;
        width: 66px;
      }
    }
    .letter-s {
      @media screen {
        height: $letterHeightMd;
        width: 60px;
      }
    }

    /* Letter spacing: */
    .ml1 {
      margin-left: -23px;
    }
    .ml2 {
      margin-left: -90px;
    }
    .mr2 {
      margin-right: -21px;
    }
    .ml3 {
      margin-left: -66px;
    }
    .mr3 {
      margin-right: -19px;
    }
    .ml4 {
      margin-left: -17px;
    }
    .ml5 {
      margin-left: -23px;
    }
  }

  /* Wide screen smart phones breakpoint: */
  $letterHeightSm: 72px;
  @media only screen and (min-width: $width-small) and (max-width: $width-medium - 1) {
    /* Letter sizing: */
    .basic-letter {
      @media screen {
        height: $letterHeightSm;
        width: 53px;
      }
    }
    .letter-flamingo {
      @media screen {
        height: 116px;
        width: 122px;
      }
    }
    .letter-dot {
      margin-bottom: 25px;
      @media screen {
        height: 18px;
        width: 18px;
      }
    }
    .letter-i {
      @media screen {
        height: $letterHeightSm;
        width: 39px;
      }
    }
    .letter-s {
      @media screen {
        height: $letterHeightSm;
        width: 38px;
      }
    }

    /* Letter spacing: */
    .ml1 {
      margin-left: -19px;
    }
    .ml2 {
      margin-left: -66px;
    }
    .mr2 {
      margin-right: -14px;
    }
    .ml3 {
      margin-left: -53px;
    }
    .mr3 {
      margin-right: -19px;
    }
    .ml4 {
      margin-left: -12px;
    }
    .ml5 {
      margin-left: -19px;
    }
  }

  /* Smart phones iPhone 6 and higher: */
  $letterHeightSm: 44px;
  $lettersBasicWidthSm: 27px;
  $dotWidthSm: 9px;
  @media only screen and (max-width: $width-small - 1) {
    /* Letter sizing: */
    .basic-letter {
      @media screen {
        height: $letterHeightSm;
        width: $lettersBasicWidthSm;
      }
    }
    .letter-flamingo {
      @media screen {
        height: $letterHeightSm * 1.8;
        width: $lettersBasicWidthSm * 3;
      }
    }
    .letter-dot {
      margin-bottom: 18px;
      @media screen {
        height: $dotWidthSm;
        width: $dotWidthSm;
      }
    }
    .letter-i {
      @media screen {
        height: $letterHeightSm;
        width: 29px;
      }
    }
    .letter-s {
      @media screen {
        height: $letterHeightSm;
        width: 26px;
      }
    }

    /* Letter spacing: */
    .ml1 {
      margin-left: -11px;
    }
    .ml2 {
      margin-left: -46px;
    }
    .mr2 {
      margin-right: -10px;
    }
    .ml3 {
      margin-left: -38px;
    }
    .mr3 {
      margin-right: -12px;
    }
    .ml4 {
      margin-left: -9px;
    }
    .ml5 {
      margin-left: -5px;
    }
  }

  @media only screen and (max-width: $width-tiny - 1) {
    .phrase-online {
      display: none;
    }
    /* Letter spacing: */
    .ml1 {
      margin-left: -4px;
    }
    .ml2 {
      margin-left: -46px;
    }
    .mr2 {
      margin-right: -10px;
    }
    .ml3 {
      margin-left: -38px;
    }
    .mr3 {
      margin-right: -12px;
    }
    .ml4 {
      margin-left: -7px;
    }
    .ml5 {
      margin-left: -5px;
    }
  }

  @media only screen and (min-width: $width-slim) {
    .phrase-simple {
      display: none;
    }
  }
  @media only screen and (max-width: $width-slim - 1) {
    .letters-container {
      padding-top: 20px;
    }
    .phrase-radio-kids {
      display: none;
    }
    .phrase-simple {
      display: inline;
    }
  }

  /* Animation: */
  $class-slug: for !default;
  @for $i from 0 through $numberOfLettersFull - 1 {
    @media only screen and (min-width: $width-small) {
      .#{$class-slug}-#{$i} {
        animation: lettersWave $animationDuration infinite normal linear;
        animation-delay: $i * $animationDelayMultiplier * $animationDuration / $numberOfLettersFull;
        animation-direction: normal;
      }
    }
    @media only screen and (max-width: $width-small - 1) {
      .#{$class-slug}-#{$i} {
        animation: lettersWave $animationDuration infinite normal linear;
        animation-delay: $i * $animationDelayMultiplier * $animationDuration / $numberOfLettersTiny;
        animation-direction: normal;
      }
    }
    .are-letters-waving .#{$class-slug}-#{$i} {
      animation-play-state: running;
    }
    .are-letters-paused .#{$class-slug}-#{$i} {
      animation-play-state: paused;
    }
  }
  @media only screen and (min-width: $width-medium) {
    @keyframes lettersWave {
      0% {
        transform: translateY(0) rotate(0deg);
      }
      25% {
        transform: translateY($animationAmplitudeBig / 2) rotate(-$animationAngle);
      }
      50% {
        transform: translateY($animationAmplitudeBig) rotate(0deg);
      }
      75% {
        transform: translateY($animationAmplitudeBig / 2) rotate($animationAngle);
      }
      100% {
        transform: translateY(0) rotate(0deg);
      }
    }
  }
  @media only screen and (min-width: $width-small) and (max-width: $width-medium - 1) {
    @keyframes lettersWave {
      0% {
        transform: translateY(0) rotate(0deg);
      }
      25% {
        transform: translateY($animationAmplitudeSmall / 2) rotate(-$animationAngle);
      }
      50% {
        transform: translateY($animationAmplitudeSmall) rotate(0deg);
      }
      75% {
        transform: translateY($animationAmplitudeSmall / 2) rotate($animationAngle);
      }
      100% {
        transform: translateY(0) rotate(0deg);
      }
    }
  }
  @media only screen and (max-width: $width-small - 1) {
    @keyframes lettersWave {
      0% {
        transform: translateY(0) rotate(0deg);
      }
      25% {
        transform: translateY($animationAmplitudeTiny / 2) rotate(-$animationAngle);
      }
      50% {
        transform: translateY($animationAmplitudeTiny) rotate(0deg);
      }
      75% {
        transform: translateY($animationAmplitudeTiny / 2) rotate($animationAngle);
      }
      100% {
        transform: translateY(0) rotate(0deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/HeadLetters.vue